export default function({ redirect, route }) {
  if (route.query.fbclid) {
    let query = Object.assign({}, route.query)
    delete query.fbclid

    const queryArray = []
    for (let key in query) {
      if (query.hasOwnProperty(key)) {
        queryArray.push(key + '=' + query[key])
      }
    }
    let resultQueryString = queryArray.join('&')
    resultQueryString = resultQueryString ? `?${resultQueryString}` : ''
    encodeURI(resultQueryString)
    return redirect(301, route.path + resultQueryString)
  }
}
